
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { OrderDetails as DetailsModel } from '@/model/OrderDetails';
import runtimeConfigLoader from '@/runtime-config-loader';
import api from '@/service/api';

@Component
export default class OrderDetails extends Vue {
    @Prop({
        type: Array,
        required: true,
    })
    headers!: Array<{ text: string; sortable?: boolean; align?: string; value: string; }>;

    @Prop({
        required: false,
    })
    details?: DetailsModel;

    backendUrl?: string;

    storageUrl!: string;

    @Prop({
        type: String,
        required: true,
    })
    sessionId!: string;

    enlargedImgSrc: string | null = null;

    async mounted() {
        const config = await runtimeConfigLoader;
        this.storageUrl = config.storageUrl;
    }

    get orderedGlobalProducts() {
        return Object.entries(this.details?.order?.globalProducts || []).reduce((carry, [ id, ordered ]) => ([
            ...carry,
            ...(ordered ? [id] : []),
        ]), [] as string[])
    }

    get products(): DetailsModel['products'] {
        return this.details?.products || {};
    }

    get formats(): DetailsModel['formats'] {
        return this.details?.formats || {};
    }

    get printsByFormat() {
        return Object.keys(this.details?.formats || {})
            .reduce(
                (carry, formatId) => {
                    const photosWithFormat = (this.details?.order?.photos || [])
                            .filter(({ prints }) => Object.keys(prints).includes(formatId));
                    return {
                        ...carry,
                        ...(photosWithFormat.length ? 
                            {
                                [formatId]: photosWithFormat.reduce((carry, photo) => ({ ...carry, [photo.filename]: photo.prints[formatId] }), {} as {[filename: string]: number})
                            } : 
                            {}
                        )
                    };
                },
                {} as {[formatId: string]: { [filename: string]: number }}
            )
    }

    get photos() {
        return (this.details?.order?.photos || []).reduce((carry, photo) => ({
            ...carry,
            [photo.filename]: {
                ...photo,
                products: Object.entries(photo.products).filter(([_, order]) => order).map(([id]) => id),
            }
        }), {} as {[filename: string]: { prints: {[formatId: string]: number}, products: string[], comment: string, digital: boolean, id: string }})
    }

    enlargePhoto(src: string) {
        this.enlargedImgSrc = src;
    }
}

